import {Route, Routes} from "react-router-dom";
import FirmwareList from "./FirmwareList";
import RequireAuth from "../../components/RequireAuth";
import {PermissionLevel} from "../../app/api/model/user";
import FirmwareDetails from "./FirmwareDetails";

export default function Firmwares() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.VIEW_ONLY}>
            <Routes>
                <Route index element={<FirmwareList />} />
                <Route path=":firmwareId" element={<FirmwareDetails />} />
            </Routes>
        </RequireAuth>
    );
}
